export type { StyledSystemProps } from './dynamic-styled-system-component'
export { default as DynamicStyledSystemComponent } from './dynamic-styled-system-component'
export { typographyStyles } from './typography-styles'
